export const URL_GENERAL_MANAGMENT_INTERNET = "gestiones-internet";
export const URL_GENERAL_MANAGMENT_MOBILE = "gestiones-linea-movil";
export const URL_GENERAL_MANAGMENT_MOBILE_BLOQUEOS = "gestiones-linea-movil-bloqueos";
export const URL_GENERAL_MANAGMENT_PHONE_BLOQUEOS = "gestiones-linea-fija-bloqueos";
export const URL_GENERAL_MANAGMENT_PHONE_MORE_MANAGMENT = "gestiones-linea-fija-mas-gestiones";
export const URL_DETOUR_PHONE_LANDLINE = "gestiones-linea-fija-desvio";

export const URL_GENERAL_MANAGMENT_MOBILE_IMEI_PUK = "gestiones-linea-movil-imei-puk";

export const URL_GENERAL_MANAGMENT_FIJO = "gestiones-linea-fija";
export const URL_GENERAL_MANAGMENT_TV = "gestiones-tv";

export const INTENET = "internet";
export const MOBILE = "movil";
export const FIJO = "fijo";
export const TV = "tv";

export const BLOCK = "bloqueo";
export const LOST = "perdidas";
export const EXTRA_DATA = "datos-extra";
export const DESVIO = "desvio";
export const PUKIMEI = "pukimei";
export const CAMBIAR_NUMERO = "cambiar-numero";
export const BLOQUEOS_A_MOVILES = "bloqueos-a-moviles";
export const CHANGE_LANDLINE = "cambiar-numero-fijo";
export const MULTI_CALL_LANDLINE = "llamada-a-tres-fijo";
export const LOST_CALL_LANDLINE = "llamada-sin-marcar-fijo";
export const CALL_REJECTION_LANDLINE = "rechazo-llamada-fijo";
export const WAITING_LANDLINE = "espera-fijo";
export const HIDING_LANDLINE = "ocultacion-fijo";
export const IDENTITI_CALL_LANDLINE = "identificacion-llamadas-fijo";
export const TRASLADE_LINE_LANDLINE = "traslado-linea-fijo";
export const BASIC_PACK_LANDLINE = "pack-basicos-fijo";
export const SERVICE_MAINTENANCE_LANDLINE = "mantenimiento-servicios-fijo";
export const CALL_RESPONSE_LANDLINE = "contestador-fijo";
export const INMEDIATE_DETOUR_LANDLINE = "desvio-inmediato-fijo";
export const COMUNICATE_DETOUR_LANDLINE = "desvio-comunico-fijo";
export const NOT_RESPONSE_DETOUR_LANDLINE = "desvio-no-respondo-fijo";
export const CALL_RESPONSE_LANDLINE_RADIO = "contestador-fijo-radio";
export const IDENTITI_CALL_LANDLINE_RADIO = "identificador-fijo-radio";
export const WAITING_LANDLINE_RADIO = "espera-fijo-radio";
export const INMEDIATE_DETOUR_LANDLINE_RADIO = "desvio-inmediato-radio";
export const COMUNICATE_DETOUR_LANDLINE_RADIO = "desvio-si-comunica-radio";
export const NOT_RESPONSE_DETOUR_LANDLINE_RADIO = "desvio-si-no-comunica-radio";
export const DIVERSION_DO_NOT_DISTURB = "desvio-no-molestar";
export const MULTI_CALL_LANDLINE_RADIO = "llamada-a-tres-radio";
export const TERMINAL_PACK = "terminal-pack";
export const ADITIONALS_LINES = "activar-linea";
export const FAST_PASS = "fast-pass";


export const IMEI = "imei";
export const DATOS_COMPARTIDOS = "datos-compartidos";
export const PUK = "puk";
export const EMOTION = "emotion";
export const ROAMING = "roaming";
export const BLOQUEOS_INTERNACIONALES = "bloqueos-internacionales";
export const BLOQUEOS_80_905 = "bloqueos-80-905";
export const BLOQUEOS_118 = "bloqueos-118";
export const BLOQUEOS_MSG_PREMIUM = "bloqueos-msg-premiun";
export const BLOQUEOS_TOTAL = "bloqueos-total";
export const BLOQUEOS_ROBO = "bloqueos-robo";

export const BUZON = "buzon";
export const BLOQUEOS = "bloqueos";
export const MORE_MANAGMENTS = "mas-gestiones";
export const PHONE_DETOUR_LANDLINE = "desvios-fijo";

export const NUMEROS = "numeros";
export const OCULTACION = "ocultacion";
export const LLAMADA_ESPERA = "llamada-espera";
export const PERDIDAS = "perdidas";
export const EMOCION = "emotion";

export const RECHARGE_PREPAGO = "recargar-prepago";
export const ANTICIPAR_PREPAGO = "anticipar-prepago";
export const ADD_BONOS_PREPAGO = "add-bonos-prepago";
export const CAMBIAR_PREPAGO = "cambiar-prepago";
export const CAMBIAR_PREPAGO_BONO = "cambiar-prepago-bono";

export const DISNEY = "disney";
export const DAZN = "dazn";
export const MAX = "max";
export const NETFLIX = "netflix";
export const SKY = "sky";
export const MOVISTAR_PLUS = "movistar-plus";
export const CONFIG_TV = "config-tv";

export const DOWNLOAD = "descargar";
export const ECO_BILL = "eco";
export const CHANGE_BANK = "bank";
export const RECHARGE = "recargar";
export const SHIPPING_ADDRESS = "direccion-envio";
export const DEBT_PAYMENT = "deuda";
export const GAME_PASS_CODE = "game-pass-code";
export const CLOUD = "cloud";
export const PERPLEXITY = "perplexity";
export const PROTECCION_DIGITAL = "proteccion-digital";

export const ACTIVATE_20_GB_GAME_PASS = "activate-20-gb-game-pass";
export const GAME_PASS_SERVICE_TYPE = "Game Pass";
export const ACTIVATE_20_GB_GAME_PASS_TITLE = "Activa tus 20 GB incluidos";
export const ACTIVATE_20_GB_GAME_PASS_POID = "1280";
export const AÑADIR_SUBSCRIPCION = "Añadir Subscripcion";
export const APP_MOVISTAR_PROSEGUR_ALARMAS = "App Movistar Prosegur Alarmas";
export const SALUD_SERVICE_TYPE = "salud";
export const RELOJ_SERVICE_TYPE = "reloj";
export const APP_MOVISTAR_SALUD = "App Movistar Salud";
export const APP_RELOJ_TE_CUIDA = "App Reloj Te Cuida";
export const COD_SERVICIO_SALUD = "00103001";
export const COD_SALUD_FAMILIAR = "C0032597";
export const COD_SALUD_PERSONAL = "C0032599";
export const GESTIONAR_SERVICIO = "Gestionar Servicio Salud";
export const GESTIONAR_ESIM = "gestionar-esim";
export const FUNCIONALITIES = "funcionalidades";
export const SERVICE_TYPE_CHANGE_BANK_ACCOUNT = "cuenta-bancaria";
export const SERVICE_TYPE_EMAIL = "email";
export const SERVICE_TYPE_PHONE = "telefono-contacto";
export const SERVICE_TYPE_PASS = "password";
export const SERVICE_TYPE_PREF = "preferencias";
export const SERVICE_TYPE_OBD = "obd";
export const RESTRICTIONS = {
  R68: "68",
  R8: "8",
  R9: "9",
  R2: "2",
  R4: "4",
  R6: "6",
  R7: "7",
  R10:"10",
  R13: "13",
  R14: "14",
  R15: "15",
  R73: "73",
};

export const MSGS_MOBILE_CHANGES = [
    "Estamos realizando tu cambio...",
    "El cambio se completará en unos segundos. Espera hasta que te indiquemos que se ha realizado.",
  ];

export const MSGS = [
  ...MSGS_MOBILE_CHANGES,
  "Estamos verificando la configuración..",
  "Ya casi hemos modificado tu configuración ...",
]; 

export const VulnerableRestrictions = {
  BLOCK_INTERNATIONAL_CALLS: "10",       // Bloquear llamadas internacionales
  TOTAL_BLOCK_1: "2",                    // Bloquear gratis todas llamadas y SMS salientes
  TOTAL_BLOCK_2: "4",                    // Bloquear gratis todas llamadas y SMS entrantes
  TOTAL_BLOCK_3: "6",                    // Bloqueo gratis datos y MMS
  BLOCK_INTERNATIONAL_CALLS_ALT: "17",   // Bloquear llamadas internacionales (alternativa)
  BLOCK_OUTGOING_CALLS: "51",            // Bloquear llamadas salientes
};